import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import { usePodcast } from '../../context/PodcastContext';
import podcastCoverDefault from '../../assets/podcast-cover.jpg';

const PodcastDialog = () => {
    const { isPodcastOpen, podcast, handleClose, handleAudioTimeUpdate } = usePodcast();

    return (
        <Dialog
            open={isPodcastOpen}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
        >
            <DialogContent sx={{ p: 0 }}>
                {/* Hero image section */}
                <Box sx={{ position: 'relative' }}>
                    <img
                        src={podcast?.image_url || podcastCoverDefault}
                        alt="Podcast Cover"
                        style={{ width: '100%', height: '300px', objectFit: 'cover', objectPosition: 'center top', display: 'block' }}
                    />
                    {/* Gradient overlay */}
                    <Box sx={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(to top, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.15) 50%, transparent 100%)',
                    }} />
                    {/* Close button */}
                    <IconButton
                        onClick={handleClose}
                        size="small"
                        sx={{
                            position: 'absolute', top: 10, right: 10,
                            backgroundColor: 'rgba(0,0,0,0.45)',
                            color: 'white',
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.65)' },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                    {/* Overlay text */}
                    <Box sx={{ position: 'absolute', bottom: 18, left: 20, right: 50 }}>
                        <Box sx={{
                            display: 'inline-flex', alignItems: 'center', gap: 0.6,
                            backgroundColor: 'rgba(34,197,94,0.25)',
                            border: '1px solid rgba(34,197,94,0.5)',
                            borderRadius: '20px', px: 1.2, py: 0.3, mb: 1,
                        }}>
                            <HeadphonesIcon sx={{ fontSize: 12, color: '#4ade80' }} />
                            <Typography sx={{ fontSize: '11px', color: '#4ade80', fontWeight: 700, letterSpacing: 0.8 }}>
                                LEARN WITH ECHO
                            </Typography>
                        </Box>
                        <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold', lineHeight: 1.3, textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>
                            Podcast
                        </Typography>
                    </Box>
                </Box>

                {/* Content section */}
                <Box sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.5 }}>
                        <Box sx={{
                            width: 4, minHeight: 44, borderRadius: 2, flexShrink: 0,
                            background: 'linear-gradient(180deg, #22c55e, #14b8a6, #8b5cf6)',
                        }} />
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                {podcast?.title}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                Today's Episode
                            </Typography>
                        </Box>
                    </Box>

                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2.5, pl: 2 }}>
                        {podcast?.description}
                    </Typography>

                    <Box sx={{
                        background: 'linear-gradient(135deg, rgba(34,197,94,0.07), rgba(20,184,166,0.07), rgba(139,92,246,0.07))',
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                        p: 1.5,
                    }}>
                        <audio
                            controls
                            controlsList="nodownload"
                            src={podcast?.podcast_url}
                            style={{ width: '100%' }}
                            onTimeUpdate={(e) => handleAudioTimeUpdate(e.target.currentTime)}
                            onEnded={() => console.log('Audio ended')}
                        />
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};

export default PodcastDialog;
